import PaymentProfile from '../../components/paymentProfile';

export default PaymentProfile;